import * as i0 from '@angular/core';
import { Component, HostBinding, Input, NgModule } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

class TextComponent {
    constructor() {
        this.hbClassType = true;
        /** Configures the alignment of the text. */
        this.alignment = 'default';
        /** Configures the size of the text. */
        this.size = 'T300';
        /** Configures the text component to have a margin-bottom. */
        this.marginBottom = false;
        /** Configures the text component to specify colour (inherit) */
        this.color = 'default';
    }
    get hbClassTypeColorInherit() {
        return this.color === 'inherit';
    }
    get hbClassTypeColorHeading() {
        return this.color === 'heading';
    }
    get hbClassTypeColorSuccess() {
        return this.color === 'success';
    }
    get hbClassTypeColorError() {
        return this.color === 'error';
    }
    get hbClassTypeColorWarning() {
        return this.color === 'warning';
    }
    get hbClassTypeColorInfo() {
        return this.color === 'info';
    }
    get hbClassTypeColorDefault() {
        return this.color === 'default';
    }
    get hbClassTypeSizeT900() {
        return this.size === 'T900';
    }
    get hbClassTypeSizeT800() {
        return this.size === 'T800';
    }
    get hbClassTypeSizeT700() {
        return this.size === 'T700';
    }
    get hbClassTypeSizeT600() {
        return this.size === 'T600';
    }
    get hbClassTypeSizeT500() {
        return this.size === 'T500';
    }
    get hbClassTypeSizeT400() {
        return this.size === 'T400';
    }
    get hbClassTypeSizeT300() {
        return this.size === 'T300';
    }
    get hbClassTypeSizeT200() {
        return this.size === 'T200';
    }
    get hbClassTypeMarginBottom() {
        return coerceBooleanProperty(this.marginBottom);
    }
    get hbClassTypeWeightHeavy() {
        return this.weight === 'heavy';
    }
    get hbClassTypeWeightBold() {
        return this.weight === 'bold';
    }
    get hbClassTypeWeightMedium() {
        return this.weight === 'medium';
    }
    get hbClassTypeWeightRegular() {
        return this.weight === 'regular';
    }
    get hbClassTypeWeightLight() {
        return this.weight === 'light';
    }
    get hbClassTypeItalic() {
        return coerceBooleanProperty(this.italic);
    }
    get hbClassTypeTextDecorationUnderline() {
        return this.decoration === 'underline';
    }
    get hbClassTypeTextDecorationStrikethrough() {
        return this.decoration === 'strikethrough';
    }
    get hbClassTypeAlignCenter() {
        return this.alignment === 'center';
    }
    get hbClassTypeAlignCenterSm() {
        return this.alignment === 'center-sm';
    }
}
TextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: TextComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: TextComponent, isStandalone: true, selector: "[vo-text]", inputs: { alignment: "alignment", size: "size", weight: "weight", marginBottom: "marginBottom", color: "color", italic: "italic", decoration: "decoration" }, host: { properties: { "class.type": "this.hbClassType", "class.type--color-inherit": "this.hbClassTypeColorInherit", "class.type--color-heading": "this.hbClassTypeColorHeading", "class.type--color-success": "this.hbClassTypeColorSuccess", "class.type--color-error": "this.hbClassTypeColorError", "class.type--color-warning": "this.hbClassTypeColorWarning", "class.type--color-info": "this.hbClassTypeColorInfo", "class.type--color-default": "this.hbClassTypeColorDefault", "class.type--size-T900": "this.hbClassTypeSizeT900", "class.type--size-T800": "this.hbClassTypeSizeT800", "class.type--size-T700": "this.hbClassTypeSizeT700", "class.type--size-T600": "this.hbClassTypeSizeT600", "class.type--size-T500": "this.hbClassTypeSizeT500", "class.type--size-T400": "this.hbClassTypeSizeT400", "class.type--size-T300": "this.hbClassTypeSizeT300", "class.type--size-T200": "this.hbClassTypeSizeT200", "class.type--margin-bottom": "this.hbClassTypeMarginBottom", "class.type--weight-heavy": "this.hbClassTypeWeightHeavy", "class.type--weight-bold": "this.hbClassTypeWeightBold", "class.type--weight-medium": "this.hbClassTypeWeightMedium", "class.type--weight-regular": "this.hbClassTypeWeightRegular", "class.type--weight-light": "this.hbClassTypeWeightLight", "class.type--style-italic": "this.hbClassTypeItalic", "class.type--text-decoration-underline": "this.hbClassTypeTextDecorationUnderline", "class.type--text-decoration-strikethrough": "this.hbClassTypeTextDecorationStrikethrough", "class.type--align-center": "this.hbClassTypeAlignCenter", "class.type--align-center-sm": "this.hbClassTypeAlignCenterSm" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host(.type){font-family:var(--mo-font-family);font-weight:var(--mo-font-weight-regular);padding:0;margin:0}:host(.type--align-center){text-align:center}:host(.type--align-center-sm){text-align:center}:host(.type--color-default){color:var(--mo-type-color)}:host(.type--color-heading){color:var(--mo-type-heading-color)}:host(.type--color-success){color:var(--mo-color-success)}:host(.type--color-error){color:var(--mo-color-error)}:host(.type--color-warning){color:var(--mo-color-warning)}:host(.type--color-info){color:var(--mo-color-info)}:host(.type--size-T900){font-size:var(--mo-type-T900-font-size);line-height:var(--mo-type-T900-line-height)}:host(.type--size-T800){font-size:var(--mo-type-T800-font-size);line-height:var(--mo-type-T800-line-height)}:host(.type--size-T700){font-size:var(--mo-type-T700-font-size);line-height:var(--mo-type-T700-line-height)}:host(.type--size-T600){font-size:var(--mo-type-T600-font-size);line-height:var(--mo-type-T600-line-height)}:host(.type--size-T500){font-size:var(--mo-type-T500-font-size);line-height:var(--mo-type-T500-line-height)}:host(.type--size-T400){font-size:var(--mo-type-T400-font-size);line-height:var(--mo-type-T400-line-height)}:host(.type--size-T300){font-size:var(--mo-type-T300-font-size);line-height:var(--mo-type-T300-line-height)}:host(.type--size-T200){font-size:var(--mo-type-T200-font-size);line-height:var(--mo-type-T200-line-height)}:host(.type--weight-light){font-weight:var(--mo-font-weight-light)}:host(.type--weight-regular){font-weight:var(--mo-font-weight-regular)}:host(.type--weight-medium){font-weight:var(--mo-font-weight-medium)}:host(.type--weight-bold){font-weight:var(--mo-font-weight-bold)}:host(.type--weight-heavy){font-weight:var(--mo-font-weight-heavy)}:host(.type) ::ng-deep strong{font-weight:var(--mo-font-weight-bold)}:host(.type) ::ng-deep em,:host(.type--style-italic){font-style:italic}:host(.type--text-decoration-underline){text-decoration:underline}:host(.type--text-decoration-strikethrough){text-decoration:line-through}:host(.type--margin-bottom){margin-bottom:var(--mo-sizing-md)}@media (min-width: 48em){:host(.type--align-center-sm){text-align:inherit}}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: TextComponent, decorators: [{
            type: Component,
            args: [{ selector: '[vo-text]', standalone: true, template: '<ng-content></ng-content>', styles: [":host(.type){font-family:var(--mo-font-family);font-weight:var(--mo-font-weight-regular);padding:0;margin:0}:host(.type--align-center){text-align:center}:host(.type--align-center-sm){text-align:center}:host(.type--color-default){color:var(--mo-type-color)}:host(.type--color-heading){color:var(--mo-type-heading-color)}:host(.type--color-success){color:var(--mo-color-success)}:host(.type--color-error){color:var(--mo-color-error)}:host(.type--color-warning){color:var(--mo-color-warning)}:host(.type--color-info){color:var(--mo-color-info)}:host(.type--size-T900){font-size:var(--mo-type-T900-font-size);line-height:var(--mo-type-T900-line-height)}:host(.type--size-T800){font-size:var(--mo-type-T800-font-size);line-height:var(--mo-type-T800-line-height)}:host(.type--size-T700){font-size:var(--mo-type-T700-font-size);line-height:var(--mo-type-T700-line-height)}:host(.type--size-T600){font-size:var(--mo-type-T600-font-size);line-height:var(--mo-type-T600-line-height)}:host(.type--size-T500){font-size:var(--mo-type-T500-font-size);line-height:var(--mo-type-T500-line-height)}:host(.type--size-T400){font-size:var(--mo-type-T400-font-size);line-height:var(--mo-type-T400-line-height)}:host(.type--size-T300){font-size:var(--mo-type-T300-font-size);line-height:var(--mo-type-T300-line-height)}:host(.type--size-T200){font-size:var(--mo-type-T200-font-size);line-height:var(--mo-type-T200-line-height)}:host(.type--weight-light){font-weight:var(--mo-font-weight-light)}:host(.type--weight-regular){font-weight:var(--mo-font-weight-regular)}:host(.type--weight-medium){font-weight:var(--mo-font-weight-medium)}:host(.type--weight-bold){font-weight:var(--mo-font-weight-bold)}:host(.type--weight-heavy){font-weight:var(--mo-font-weight-heavy)}:host(.type) ::ng-deep strong{font-weight:var(--mo-font-weight-bold)}:host(.type) ::ng-deep em,:host(.type--style-italic){font-style:italic}:host(.type--text-decoration-underline){text-decoration:underline}:host(.type--text-decoration-strikethrough){text-decoration:line-through}:host(.type--margin-bottom){margin-bottom:var(--mo-sizing-md)}@media (min-width: 48em){:host(.type--align-center-sm){text-align:inherit}}\n"] }]
        }], propDecorators: { hbClassType: [{
                type: HostBinding,
                args: ['class.type']
            }], hbClassTypeColorInherit: [{
                type: HostBinding,
                args: ['class.type--color-inherit']
            }], hbClassTypeColorHeading: [{
                type: HostBinding,
                args: ['class.type--color-heading']
            }], hbClassTypeColorSuccess: [{
                type: HostBinding,
                args: ['class.type--color-success']
            }], hbClassTypeColorError: [{
                type: HostBinding,
                args: ['class.type--color-error']
            }], hbClassTypeColorWarning: [{
                type: HostBinding,
                args: ['class.type--color-warning']
            }], hbClassTypeColorInfo: [{
                type: HostBinding,
                args: ['class.type--color-info']
            }], hbClassTypeColorDefault: [{
                type: HostBinding,
                args: ['class.type--color-default']
            }], hbClassTypeSizeT900: [{
                type: HostBinding,
                args: ['class.type--size-T900']
            }], hbClassTypeSizeT800: [{
                type: HostBinding,
                args: ['class.type--size-T800']
            }], hbClassTypeSizeT700: [{
                type: HostBinding,
                args: ['class.type--size-T700']
            }], hbClassTypeSizeT600: [{
                type: HostBinding,
                args: ['class.type--size-T600']
            }], hbClassTypeSizeT500: [{
                type: HostBinding,
                args: ['class.type--size-T500']
            }], hbClassTypeSizeT400: [{
                type: HostBinding,
                args: ['class.type--size-T400']
            }], hbClassTypeSizeT300: [{
                type: HostBinding,
                args: ['class.type--size-T300']
            }], hbClassTypeSizeT200: [{
                type: HostBinding,
                args: ['class.type--size-T200']
            }], hbClassTypeMarginBottom: [{
                type: HostBinding,
                args: ['class.type--margin-bottom']
            }], hbClassTypeWeightHeavy: [{
                type: HostBinding,
                args: ['class.type--weight-heavy']
            }], hbClassTypeWeightBold: [{
                type: HostBinding,
                args: ['class.type--weight-bold']
            }], hbClassTypeWeightMedium: [{
                type: HostBinding,
                args: ['class.type--weight-medium']
            }], hbClassTypeWeightRegular: [{
                type: HostBinding,
                args: ['class.type--weight-regular']
            }], hbClassTypeWeightLight: [{
                type: HostBinding,
                args: ['class.type--weight-light']
            }], hbClassTypeItalic: [{
                type: HostBinding,
                args: ['class.type--style-italic']
            }], hbClassTypeTextDecorationUnderline: [{
                type: HostBinding,
                args: ['class.type--text-decoration-underline']
            }], hbClassTypeTextDecorationStrikethrough: [{
                type: HostBinding,
                args: ['class.type--text-decoration-strikethrough']
            }], hbClassTypeAlignCenter: [{
                type: HostBinding,
                args: ['class.type--align-center']
            }], hbClassTypeAlignCenterSm: [{
                type: HostBinding,
                args: ['class.type--align-center-sm']
            }], alignment: [{
                type: Input
            }], size: [{
                type: Input
            }], weight: [{
                type: Input
            }], marginBottom: [{
                type: Input
            }], color: [{
                type: Input
            }], italic: [{
                type: Input
            }], decoration: [{
                type: Input
            }] } });

/**
 * @deprecated The vo-text component should be used instead
 */
class HeadingComponent {
    constructor() {
        this.hbClassType = true;
        this.alignment = 'default';
        /** Configures the size of the heading. */
        this.size = 'T700';
        /** Configures the weight of the heading */
        this.weight = 'regular';
        /** Configures the heading component to have a margin-bottom. */
        this.marginBottom = false;
        /** Configures the text component to specify colour (inherit) */
        this.color = 'default';
    }
    get hbClassTypeColorInherit() {
        return this.color === 'inherit';
    }
    get hbClassTypeColorDefault() {
        return this.color === 'default';
    }
    get hbClassTypeSizeT900() {
        return this.size === 'T900';
    }
    get hbClassTypeSizeT800() {
        return this.size === 'T800';
    }
    get hbClassTypeSizeT700() {
        return this.size === 'T700';
    }
    get hbClassTypeSizeT600() {
        return this.size === 'T600';
    }
    get hbClassTypeSizeT500() {
        return this.size === 'T500';
    }
    get hbClassTypeSizeT400() {
        return this.size === 'T400';
    }
    get hbClassTypeMarginBottom() {
        return coerceBooleanProperty(this.marginBottom);
    }
    get hbClassTypeWeightHeavy() {
        return this.weight === 'heavy';
    }
    get hbClassTypeWeightBold() {
        return this.weight === 'bold';
    }
    get hbClassTypeWeightMedium() {
        return this.weight === 'medium';
    }
    get hbClassTypeWeightRegular() {
        return this.weight === 'regular';
    }
    get hbClassTypeWeightLight() {
        return this.weight === 'light';
    }
    get hbClassTypeItalic() {
        return coerceBooleanProperty(this.italic);
    }
    get hbClassTypeTextDecorationUnderline() {
        return this.decoration === 'underline';
    }
    get hbClassTypeTextDecorationStrikethrough() {
        return this.decoration === 'strikethrough';
    }
    get hbClassTypeAlignCenter() {
        return this.alignment === 'center';
    }
}
HeadingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: HeadingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HeadingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: HeadingComponent, isStandalone: true, selector: "[vo-heading]", inputs: { alignment: "alignment", size: "size", weight: "weight", marginBottom: "marginBottom", color: "color", italic: "italic", decoration: "decoration" }, host: { properties: { "class.type": "this.hbClassType", "class.type--color-inherit": "this.hbClassTypeColorInherit", "class.type--color-default": "this.hbClassTypeColorDefault", "class.type--size-T900": "this.hbClassTypeSizeT900", "class.type--size-T800": "this.hbClassTypeSizeT800", "class.type--size-T700": "this.hbClassTypeSizeT700", "class.type--size-T600": "this.hbClassTypeSizeT600", "class.type--size-T500": "this.hbClassTypeSizeT500", "class.type--size-T400": "this.hbClassTypeSizeT400", "class.type--margin-bottom": "this.hbClassTypeMarginBottom", "class.type--weight-heavy": "this.hbClassTypeWeightHeavy", "class.type--weight-bold": "this.hbClassTypeWeightBold", "class.type--weight-medium": "this.hbClassTypeWeightMedium", "class.type--weight-regular": "this.hbClassTypeWeightRegular", "class.type--weight-light": "this.hbClassTypeWeightLight", "class.type--style-italic": "this.hbClassTypeItalic", "class.type--text-decoration-underline": "this.hbClassTypeTextDecorationUnderline", "class.type--text-decoration-strikethrough": "this.hbClassTypeTextDecorationStrikethrough", "class.type--align-center": "this.hbClassTypeAlignCenter" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host(.type){font-family:var(--mo-font-family);font-weight:var(--mo-font-weight-regular);padding:0;margin:0}:host(.type--align-center){text-align:center}:host(.type--align-center-sm){text-align:center}:host(.type--color-default){color:var(--mo-type-color)}:host(.type--color-heading){color:var(--mo-type-heading-color)}:host(.type--color-success){color:var(--mo-color-success)}:host(.type--color-error){color:var(--mo-color-error)}:host(.type--color-warning){color:var(--mo-color-warning)}:host(.type--color-info){color:var(--mo-color-info)}:host(.type--size-T900){font-size:var(--mo-type-T900-font-size);line-height:var(--mo-type-T900-line-height)}:host(.type--size-T800){font-size:var(--mo-type-T800-font-size);line-height:var(--mo-type-T800-line-height)}:host(.type--size-T700){font-size:var(--mo-type-T700-font-size);line-height:var(--mo-type-T700-line-height)}:host(.type--size-T600){font-size:var(--mo-type-T600-font-size);line-height:var(--mo-type-T600-line-height)}:host(.type--size-T500){font-size:var(--mo-type-T500-font-size);line-height:var(--mo-type-T500-line-height)}:host(.type--size-T400){font-size:var(--mo-type-T400-font-size);line-height:var(--mo-type-T400-line-height)}:host(.type--size-T300){font-size:var(--mo-type-T300-font-size);line-height:var(--mo-type-T300-line-height)}:host(.type--size-T200){font-size:var(--mo-type-T200-font-size);line-height:var(--mo-type-T200-line-height)}:host(.type--weight-light){font-weight:var(--mo-font-weight-light)}:host(.type--weight-regular){font-weight:var(--mo-font-weight-regular)}:host(.type--weight-medium){font-weight:var(--mo-font-weight-medium)}:host(.type--weight-bold){font-weight:var(--mo-font-weight-bold)}:host(.type--weight-heavy){font-weight:var(--mo-font-weight-heavy)}:host(.type) ::ng-deep strong{font-weight:var(--mo-font-weight-bold)}:host(.type) ::ng-deep em,:host(.type--style-italic){font-style:italic}:host(.type--text-decoration-underline){text-decoration:underline}:host(.type--text-decoration-strikethrough){text-decoration:line-through}:host(.type--margin-bottom){margin-bottom:var(--mo-sizing-md)}@media (min-width: 48em){:host(.type--align-center-sm){text-align:inherit}}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: HeadingComponent, decorators: [{
            type: Component,
            args: [{ selector: '[vo-heading]', standalone: true, template: '<ng-content></ng-content>', styles: [":host(.type){font-family:var(--mo-font-family);font-weight:var(--mo-font-weight-regular);padding:0;margin:0}:host(.type--align-center){text-align:center}:host(.type--align-center-sm){text-align:center}:host(.type--color-default){color:var(--mo-type-color)}:host(.type--color-heading){color:var(--mo-type-heading-color)}:host(.type--color-success){color:var(--mo-color-success)}:host(.type--color-error){color:var(--mo-color-error)}:host(.type--color-warning){color:var(--mo-color-warning)}:host(.type--color-info){color:var(--mo-color-info)}:host(.type--size-T900){font-size:var(--mo-type-T900-font-size);line-height:var(--mo-type-T900-line-height)}:host(.type--size-T800){font-size:var(--mo-type-T800-font-size);line-height:var(--mo-type-T800-line-height)}:host(.type--size-T700){font-size:var(--mo-type-T700-font-size);line-height:var(--mo-type-T700-line-height)}:host(.type--size-T600){font-size:var(--mo-type-T600-font-size);line-height:var(--mo-type-T600-line-height)}:host(.type--size-T500){font-size:var(--mo-type-T500-font-size);line-height:var(--mo-type-T500-line-height)}:host(.type--size-T400){font-size:var(--mo-type-T400-font-size);line-height:var(--mo-type-T400-line-height)}:host(.type--size-T300){font-size:var(--mo-type-T300-font-size);line-height:var(--mo-type-T300-line-height)}:host(.type--size-T200){font-size:var(--mo-type-T200-font-size);line-height:var(--mo-type-T200-line-height)}:host(.type--weight-light){font-weight:var(--mo-font-weight-light)}:host(.type--weight-regular){font-weight:var(--mo-font-weight-regular)}:host(.type--weight-medium){font-weight:var(--mo-font-weight-medium)}:host(.type--weight-bold){font-weight:var(--mo-font-weight-bold)}:host(.type--weight-heavy){font-weight:var(--mo-font-weight-heavy)}:host(.type) ::ng-deep strong{font-weight:var(--mo-font-weight-bold)}:host(.type) ::ng-deep em,:host(.type--style-italic){font-style:italic}:host(.type--text-decoration-underline){text-decoration:underline}:host(.type--text-decoration-strikethrough){text-decoration:line-through}:host(.type--margin-bottom){margin-bottom:var(--mo-sizing-md)}@media (min-width: 48em){:host(.type--align-center-sm){text-align:inherit}}\n"] }]
        }], propDecorators: { hbClassType: [{
                type: HostBinding,
                args: ['class.type']
            }], hbClassTypeColorInherit: [{
                type: HostBinding,
                args: ['class.type--color-inherit']
            }], hbClassTypeColorDefault: [{
                type: HostBinding,
                args: ['class.type--color-default']
            }], hbClassTypeSizeT900: [{
                type: HostBinding,
                args: ['class.type--size-T900']
            }], hbClassTypeSizeT800: [{
                type: HostBinding,
                args: ['class.type--size-T800']
            }], hbClassTypeSizeT700: [{
                type: HostBinding,
                args: ['class.type--size-T700']
            }], hbClassTypeSizeT600: [{
                type: HostBinding,
                args: ['class.type--size-T600']
            }], hbClassTypeSizeT500: [{
                type: HostBinding,
                args: ['class.type--size-T500']
            }], hbClassTypeSizeT400: [{
                type: HostBinding,
                args: ['class.type--size-T400']
            }], hbClassTypeMarginBottom: [{
                type: HostBinding,
                args: ['class.type--margin-bottom']
            }], hbClassTypeWeightHeavy: [{
                type: HostBinding,
                args: ['class.type--weight-heavy']
            }], hbClassTypeWeightBold: [{
                type: HostBinding,
                args: ['class.type--weight-bold']
            }], hbClassTypeWeightMedium: [{
                type: HostBinding,
                args: ['class.type--weight-medium']
            }], hbClassTypeWeightRegular: [{
                type: HostBinding,
                args: ['class.type--weight-regular']
            }], hbClassTypeWeightLight: [{
                type: HostBinding,
                args: ['class.type--weight-light']
            }], hbClassTypeItalic: [{
                type: HostBinding,
                args: ['class.type--style-italic']
            }], hbClassTypeTextDecorationUnderline: [{
                type: HostBinding,
                args: ['class.type--text-decoration-underline']
            }], hbClassTypeTextDecorationStrikethrough: [{
                type: HostBinding,
                args: ['class.type--text-decoration-strikethrough']
            }], hbClassTypeAlignCenter: [{
                type: HostBinding,
                args: ['class.type--align-center']
            }], alignment: [{
                type: Input
            }], size: [{
                type: Input
            }], weight: [{
                type: Input
            }], marginBottom: [{
                type: Input
            }], color: [{
                type: Input
            }], italic: [{
                type: Input
            }], decoration: [{
                type: Input
            }] } });

class TypeModule {
}
TypeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: TypeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TypeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.0", ngImport: i0, type: TypeModule, imports: [HeadingComponent, TextComponent], exports: [HeadingComponent, TextComponent] });
TypeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: TypeModule, imports: [HeadingComponent, TextComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: TypeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [HeadingComponent, TextComponent],
                    exports: [HeadingComponent, TextComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { HeadingComponent, TextComponent, TypeModule };
